import { Link } from 'react-router-dom';

export default function HomePage() {
  return (
    <div className="bg-black text-white min-h-screen">
      {/* Navigation */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-black/95 backdrop-blur-sm">
        <div className="px-4 md:px-8 h-16 md:h-20 flex items-center justify-between">
          <Link to="/" className="text-xl md:text-2xl font-bold tracking-wider cursor-pointer">
            SOUL
          </Link>
          <Link 
            to="/" 
            className="text-white/80 hover:text-white transition-colors text-xs md:text-sm tracking-wide flex items-center gap-2 cursor-pointer"
          >
            <i className="ri-arrow-left-line"></i>
            <span className="hidden sm:inline">Volver al inicio</span>
            <span className="sm:hidden">Inicio</span>
          </Link>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="pt-24 md:pt-32 pb-12 md:pb-20 px-4 md:px-8">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-4xl md:text-6xl font-bold text-white mb-4 md:mb-6">
            Compra tu entrada
          </h1>
          <p className="text-base md:text-xl text-[#CCCCCC] max-w-2xl mx-auto">
            El pago se realiza únicamente por{' '}
            <span className="text-[#A855F7] font-semibold">Yape</span> o{' '}
            <span className="text-[#EC4899] font-semibold">Plin</span>. Elige tu método preferido y sigue los pasos.
          </p>
        </div>
      </section>

      {/* Payment Methods Section */}
      <section className="py-8 md:py-16 px-4 md:px-8">
        <div className="max-w-5xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-10">
            {/* Yape Card */}
            <div className="bg-gradient-to-br from-[#A855F7]/10 to-transparent border border-[#A855F7]/30 rounded-3xl p-6 md:p-10 text-center">
              <div className="inline-flex items-center gap-2 md:gap-3 bg-[#A855F7] text-white px-4 md:px-6 py-1.5 md:py-2 rounded-full text-base md:text-lg font-bold mb-6 md:mb-8">
                <span>💜</span> YAPE
              </div>
              <div className="w-48 h-48 md:w-64 md:h-64 mx-auto bg-white rounded-2xl p-3 md:p-4 mb-6 md:mb-8">
                <img 
                  src="https://static.readdy.ai/image/3e793795e87845ada69b8088167d8f30/b3ec157e02d44621b78870d1534a92fc.jpeg"
                  alt="QR Yape"
                  className="w-full h-full object-contain"
                />
              </div>
              <p className="text-[#CCCCCC] text-xs md:text-sm mb-2">
                Escanea el código con tu app de Yape
              </p>
            </div>

            {/* Plin Card */}
            <div className="bg-gradient-to-br from-[#EC4899]/10 to-transparent border border-[#EC4899]/30 rounded-3xl p-6 md:p-10 text-center">
              <div className="inline-flex items-center gap-2 md:gap-3 bg-[#EC4899] text-white px-4 md:px-6 py-1.5 md:py-2 rounded-full text-base md:text-lg font-bold mb-6 md:mb-8">
                <span>💗</span> PLIN
              </div>
              <div className="w-48 h-48 md:w-64 md:h-64 mx-auto bg-white rounded-2xl p-3 md:p-4 mb-6 md:mb-8">
                <img 
                  src="https://static.readdy.ai/image/3e793795e87845ada69b8088167d8f30/f17c710da3229353b2ae9c554b2e3062.jpeg"
                  alt="QR Plin"
                  className="w-full h-full object-contain"
                />
              </div>
              <p className="text-[#CCCCCC] text-xs md:text-sm mb-2">
                Escanea el código con tu app de Plin
              </p>
            </div>
          </div>

          {/* Phone Number */}
          <div className="mt-8 md:mt-12 text-center">
            <div className="inline-flex items-center gap-3 md:gap-4 bg-[#1A1A1A] border border-[#333] rounded-2xl px-6 md:px-8 py-4 md:py-5">
              <div className="w-8 h-8 md:w-10 md:h-10 flex items-center justify-center">
                <i className="ri-smartphone-line text-xl md:text-2xl text-[#A855F7]"></i>
              </div>
              <div className="text-left">
                <p className="text-xs md:text-sm text-[#999]">¿No puedes escanear? Usa este número:</p>
                <p className="text-xl md:text-2xl font-bold text-white tracking-wider">994 964 216</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* WhatsApp Section */}
      <section className="py-12 md:py-20 px-4 md:px-8 bg-gradient-to-b from-transparent to-[#0A0A0A]">
        <div className="max-w-3xl mx-auto text-center">
          <div className="bg-[#1A1A1A] border border-[#333] rounded-3xl p-8 md:p-12">
            <div className="w-12 h-12 md:w-16 md:h-16 flex items-center justify-center mx-auto mb-4 md:mb-6 bg-gradient-to-br from-[#A855F7] to-[#EC4899] rounded-full">
              <i className="ri-send-plane-fill text-2xl md:text-3xl text-white"></i>
            </div>
            <p className="text-lg md:text-2xl text-white mb-3 md:mb-4 font-medium">
              Luego de realizar el pago, envía tu comprobante para recibir tu código de ingreso.
            </p>
            <p className="text-sm md:text-base text-[#999] mb-8 md:mb-10">
              Te responderemos lo más pronto posible con tu código único.
            </p>
            <a 
              href="https://wa.me/51994964216?text=Hola%2C%20ya%20realic%C3%A9%20el%20pago%20de%20mi%20entrada%20para%20SOUL.%20Adjunto%20mi%20comprobante."
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 md:gap-3 bg-[#25D366] hover:bg-[#20BD5A] text-white px-8 md:px-12 py-4 md:py-5 rounded-full text-base md:text-xl font-bold transition-all hover:scale-105 hover:shadow-[0_0_40px_rgba(37,211,102,0.4)] whitespace-nowrap cursor-pointer"
            >
              <i className="ri-whatsapp-line text-xl md:text-2xl"></i>
              <span className="hidden sm:inline">Enviar comprobante por WhatsApp</span>
              <span className="sm:hidden">Enviar comprobante</span>
            </a>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-black py-8 md:py-12 border-t border-[#1A1A1A]">
        <div className="max-w-[1400px] mx-auto px-4 md:px-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4 md:gap-0">
            <Link to="/" className="text-lg md:text-xl font-bold cursor-pointer">
              SOUL
            </Link>
            <p className="text-xs text-[#555555]">SOUL © 2025</p>
          </div>
        </div>
      </footer>
    </div>
  );
}
